import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {I18nBundleInterface, JsonI18nBundleInterface} from '../../models/sharedinterface';
import {HttpClient} from '@angular/common/http';
import {GlobalsService} from './globals.service';
import {map} from 'rxjs/operators';
import {ShareddataService} from './shareddata.service';

@Injectable({
  providedIn: 'root'
})
export class I18nService {

  serverRoot: string;

  i18nBundles: {} = {};

  constructor(protected http: HttpClient, private globalsservice: GlobalsService,
              private shareddata: ShareddataService) {
    this.serverRoot = this.globalsservice.getBffapiroot();
    // Subscribes to the global bundle
    this.getI18nBundle('global').subscribe();
  }

  public getI18nBundle(bundleName: string): Observable<I18nBundleInterface> {
    // Returns the cached bundle
    if (this.i18nBundles && this.i18nBundles[bundleName]) {
      return of(this.i18nBundles[bundleName]);
    }

    this.i18nBundles[bundleName] = {};

    // Fetches the bundle
    const url = bundleName === 'global' ? '/i18n' : '/v1/i18n/' + bundleName;
    const query = this.http.get<JsonI18nBundleInterface>(this.serverRoot + url);
    return query.pipe(
      // Saves the bundle
      map(data => this.i18nBundles[bundleName] = data.results)
    );
  }

  public get(keyword: string, bundleName = 'global') {
    const lang = this.shareddata.getCurrentlanguage().key;
    const text = this.i18nBundles[bundleName][lang] ? this.i18nBundles[bundleName][lang][keyword] : keyword;
    return text;
  }
}
